export default {
      id: "warning-usage",
      viewBox: "0 0 16 13",
      url: "assets/" + "sprite.svg#warning-usage",
      toString: function () {
        return this.url;
      }
    }